import React from 'react'
import Image, { ImageProps } from 'next/image'
import { createMarkup } from '../../utils/helpers'
import CustomImage, { CustomImageProps } from '../customImage/CustomImage'

import styles from './ImageQuote.module.scss'

export type ImageQuoteProps = {
  quote: string
  author: string
  image: any
}

const ImageQuote = ({ ...props }: ImageQuoteProps) => {
  return (
    <section className={styles.container}>
      <div className={styles.innerContainer}>
        <div className={styles.quoteContainer}>
          <div
            className={styles.quote}
            dangerouslySetInnerHTML={createMarkup(props.quote)}
          ></div>
          <div
            className={styles.author}
            dangerouslySetInnerHTML={createMarkup(props.author)}
          ></div>
        </div>
      </div>
      <div className={styles.imageContainer}>
        <div className={styles.image}>
          <CustomImage layout="fill" objectFit="cover" src={props.image} />
        </div>
      </div>
    </section>
  )
}

export default ImageQuote
